import { CUSTOMER_JOURNEY_CATEGORIES, CUSTOMER_JOURNEY_CATEGORIES_SUCCESS, CUSTOMER_JOURNEY_CATEGORIES_ERROR } from './../../actions/const';
import { SET_TOKEN, SET_LANG } from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';
import defer from 'lodash/defer';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  apiData: [],
  loading: false
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_CATEGORIES: {
      nextState.loading = true;
      nextState.apiData = [];
      CustomerJourneySource.categories(action.token, action.lang, action.successCallback, action.errorCallback, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_CATEGORIES_SUCCESS: {
      nextState.loading = false;
      nextState.apiData = action.data;
      if(action.successCallback) defer(action.successCallback, action.data);
      return nextState;
    }
    case CUSTOMER_JOURNEY_CATEGORIES_ERROR: {
      nextState.loading = false;
      nextState.apiData = [];
      if(action.errorCallback) defer(action.errorCallback);
      return nextState;
    }
    case SET_TOKEN:
    case SET_LANG: {
      if(!isEmpty(state.apiData)) {
        nextState.loading = true;
        nextState.apiData = [];
        CustomerJourneySource.categories(action.token, action.lang, null, null, action.context);
        return nextState;
      }
      else {
        return state;
      }
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/categories.js